/* ==========================================================
   EXQUISITE TILE — CARRITO RÁPIDO DE MUESTRAS
   ----------------------------------------------------------
   - Cualquier botón con [data-ex-sample][data-variant-id]
     agrega esa muestra al carrito y abre el panel lateral
     "Product added to cart" con View Cart / Checkout.
   - [data-ex-checkout] quita del carrito las líneas de
     COTIZACIÓN (no pagables) y manda al checkout.
   - El "Add to cart" de la página de producto (formularios dentro de
     <product-form data-ex-quick>) también abre el panel lateral en
     vez de ir a la página del carrito. Respeta la cantidad elegida.
   - Todo usa delegación de eventos: funciona aunque Shopify
     recargue secciones (filtros, paginación, editor).
   ========================================================== */
(function () {
  'use strict';

  // Evita cargar dos veces (seguridad total)
  if (window.ExCart) return;

  var cfg = window.ExConfig || {};
  var ROOT = cfg.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var drawer = null;
  var lastFocus = null;
  var busy = false;

  // EXQUISITE: caché del "guard" (qué líneas del carrito son de cotización).
  // Antes, cada click en Checkout esperaba una llamada de red nueva para
  // saber esto — eso se sentía lento. Ahora se precarga en segundo plano
  // (al cargar la página y cada vez que se agrega algo al carrito) y se
  // guarda por 15 segundos. Checkout casi siempre usa el dato ya listo,
  // sin esperar nada. Si el caché expiró, cae de vuelta a pedirlo fresco
  // (nunca manda a pagar con un dato viejo/incorrecto).
  var guardCache = null;
  var guardCacheAt = 0;
  var GUARD_TTL = 15000;

  /* ---------- Utilidades ---------- */

  // Formatea centavos a dinero (ej: 600 -> $6.00)
  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cfg.currency || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  // Escapa texto para meterlo en HTML sin riesgo
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Petición JSON con manejo de errores de Shopify
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var msg = data.description || data.message || 'Something went wrong. Please try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  // Actualiza la burbuja del carrito en el header
  function updateCartBubble(sectionsHtml) {
    if (!sectionsHtml || !sectionsHtml['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sectionsHtml['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
  }

  // Avisa al resto del tema Trade que el carrito cambió
  function publishCartUpdate(data) {
    try {
      // PUB_SUB_EVENTS es "const" global en constants.js (no vive en window)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ex-sample', cartData: data });
      }
    } catch (e) { /* silencioso */ }
    document.dispatchEvent(new CustomEvent('ex:cart-updated', { detail: data }));
  }

  /* ---------- Panel lateral ---------- */

  function getDrawer() {
    if (!drawer) drawer = document.getElementById('ExSampleDrawer');
    return drawer;
  }

  function setError(msg) {
    var d = getDrawer();
    if (!d) return;
    var box = d.querySelector('[data-ex-drawer-error]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.classList.add('ex-lock-scroll');
    // Doble frame para que la animación siempre corra
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('is-open');
        var panel = d.querySelector('.ex-drawer__panel');
        if (panel) panel.focus({ preventScroll: true });
      });
    });
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('ex-lock-scroll');
    setTimeout(function () {
      d.hidden = true;
      setError('');
    }, 320);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  function renderLoading() {
    var d = getDrawer();
    if (!d) return;
    d.querySelector('[data-ex-drawer-body]').innerHTML = '<div class="ex-drawer__loading">Adding to cart…</div>';
  }

  function renderItem(item, cart) {
    var d = getDrawer();
    if (!d) return;
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    var title = item.product_title || item.title || '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var html =
      '<div class="ex-drawer__item">' +
        '<div class="ex-drawer__thumb">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" width="88" height="88">' : '') + '</div>' +
        '<div>' +
          '<p class="ex-drawer__name">' + esc(title) + (variant ? ' — ' + esc(variant) : '') + '</p>' +
          '<p class="ex-drawer__price">' + money(item.final_price != null ? item.final_price : item.price) + '</p>' +
        '</div>' +
      '</div>';
    if (cart && cart.item_count > 1) {
      html += '<p class="ex-drawer__summary">' + cart.item_count + ' items in your cart</p>';
    }
    d.querySelector('[data-ex-drawer-body]').innerHTML = html;
  }

  /* ---------- Agregar al carrito (flujo común) ---------- */

  // Después de agregar: burbuja del carrito + contenido del panel
  function afterAdd(data) {
    // /cart/add.js devuelve {items:[...]} (JSON) o el item directo (FormData)
    var added = data.items && data.items[0] ? data.items[0] : data;
    updateCartBubble(data.sections);
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (cart) {
        renderItem(added, cart);
        publishCartUpdate(cart || data);
        // El carrito cambió: refresca el caché del guard en segundo plano
        // para que el próximo click en Checkout no tenga que esperar.
        refreshGuardCache();
      });
  }

  function onAddError(err) {
    var d = getDrawer();
    if (d) d.querySelector('[data-ex-drawer-body]').innerHTML = '';
    setError(err && err.message ? err.message : 'Something went wrong. Please try again.');
  }

  // Botones [data-ex-sample]: muestras y "Add to cart" de las tarjetas (cantidad 1)
  function addSample(variantId, trigger) {
    variantId = parseInt(variantId, 10);
    if (!variantId || busy) return Promise.resolve();
    busy = true;

    if (trigger) trigger.classList.add('is-loading');
    setError('');
    renderLoading();
    openDrawer();

    return postJSON(ROOT + 'cart/add.js', {
      items: [{ id: variantId, quantity: 1 }],
      sections: 'cart-icon-bubble',
      sections_url: window.location.pathname
    })
      .then(afterAdd)
      .catch(onAddError)
      .then(function () {
        busy = false;
        if (trigger) trigger.classList.remove('is-loading');
      });
  }

  // Formulario de la página de producto (respeta cantidad y propiedades)
  function addFromForm(form, submitBtn) {
    if (busy) return Promise.resolve();
    busy = true;

    if (submitBtn) {
      submitBtn.classList.add('loading');
      submitBtn.setAttribute('aria-disabled', 'true');
    }
    setError('');
    renderLoading();
    openDrawer();

    // FormData incluye también el campo "quantity" que vive fuera del form (atributo form="...")
    var fd = new FormData(form);
    fd.append('sections', 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          }
          return data;
        });
      })
      .then(afterAdd)
      .catch(onAddError)
      .then(function () {
        busy = false;
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
        }
      });
  }

  /* ---------- Checkout seguro ---------- */

  // Pregunta a Shopify (sección ex-cart-guard) qué líneas son de cotización
  function readGuard() {
    return fetch(ROOT + '?sections=ex-cart-guard', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['ex-cart-guard'] || '', 'text/html');
        var node = doc.querySelector('[data-ex-cart-guard]');
        return node ? JSON.parse(node.textContent) : { quoteKeys: [] };
      });
  }

  // Refresca el caché del guard en segundo plano (no bloquea nada).
  // Si falla, asume "no hay cotización" — nunca deja un checkout colgado.
  function refreshGuardCache() {
    guardCacheAt = Date.now();
    guardCache = readGuard().catch(function () {
      return { quoteKeys: [] };
    });
    return guardCache;
  }

  // Usa el caché si todavía está "fresco"; si no, lo pide de nuevo.
  function getGuard() {
    if (guardCache && Date.now() - guardCacheAt < GUARD_TTL) return guardCache;
    return refreshGuardCache();
  }

  function checkout(trigger) {
    if (trigger) {
      trigger.classList.add('is-loading');
      trigger.setAttribute('data-ex-label', trigger.textContent);
      trigger.textContent = 'Processing…';
    }
    setError('');

    return getGuard()
      .then(function (guard) {
        var keys = (guard.quoteKeys || []).filter(Boolean);
        if (!keys.length) return guard;
        // Quita del carrito los azulejos de cotización antes de pagar
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return postJSON(ROOT + 'cart/update.js', { updates: updates });
      })
      .then(function () {
        window.location.href = ROOT + 'checkout';
      })
      .catch(function () {
        // Si algo falla, mejor mandar al carrito que perder la venta
        window.location.href = cfg.cartUrl || ROOT + 'cart';
      });
  }

  /* ---------- Eventos (delegación global) ---------- */

  document.addEventListener('click', function (e) {
    var sampleBtn = e.target.closest('[data-ex-sample]');
    if (sampleBtn) {
      e.preventDefault();
      addSample(sampleBtn.getAttribute('data-variant-id'), sampleBtn);
      return;
    }

    var checkoutBtn = e.target.closest('[data-ex-checkout]');
    if (checkoutBtn) {
      e.preventDefault();
      checkout(checkoutBtn);
      return;
    }

    if (e.target.closest('[data-ex-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var pf = form.closest('product-form[data-ex-quick]');
    if (!pf) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"][name="add"]') || pf.querySelector('.product-form__submit');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    addFromForm(form, btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Si el navegador vuelve con "atrás" desde checkout, restaura botones
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-ex-checkout].is-loading').forEach(function (b) {
      b.classList.remove('is-loading');
      if (b.getAttribute('data-ex-label')) b.textContent = b.getAttribute('data-ex-label');
    });
  });

  /* ---------- Swatches de tarjeta: cambia la imagen al pasar el mouse ---------- */

  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.ex-card__swatch[data-hover-img]');
      if (!sw) return;
      var card = sw.closest('.ex-card');
      var img = card && card.querySelector('.ex-card__img1');
      if (!img) return;
      if (!img.hasAttribute('data-orig-src')) {
        img.setAttribute('data-orig-src', img.getAttribute('src') || '');
        img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
      }
      img.removeAttribute('srcset');
      img.src = sw.getAttribute('data-hover-img');
    });

    document.addEventListener('mouseout', function (e) {
      var box = e.target.closest('.ex-card__swatches');
      if (!box || box.contains(e.relatedTarget)) return;
      var card = box.closest('.ex-card');
      var img = card && card.querySelector('.ex-card__img1');
      if (!img || !img.hasAttribute('data-orig-src')) return;
      img.src = img.getAttribute('data-orig-src');
      var set = img.getAttribute('data-orig-srcset');
      if (set) img.setAttribute('srcset', set);
    });
  }

  // Precarga el guard al cargar la página (en segundo plano, no bloquea
  // nada). Así, aunque el cliente nunca agregue nada más, el primer click
  // en Checkout ya encuentra el dato listo.
  refreshGuardCache();

  // API pública (por si se necesita desde otro código)
  window.ExCart = {
    addSample: addSample,
    addFromForm: addFromForm,
    checkout: checkout,
    open: openDrawer,
    close: closeDrawer,
    money: money
  };
})();